import type { IControlSettingUI } from '../types';

export const execControlCondition = (condition: string, variables: string[]) => {
  try {
    const fn = new Function(`${variables.join(';')};return ${condition}`); // eslint-disable-line
    return fn();
  } catch {
    return false;
  }
};

const evaluateHide = (
  baseHide: boolean | undefined,
  condition: string | undefined,
  variables: string[],
): boolean => {
  if (!condition) return baseHide ?? false;
  return execControlCondition(condition, variables);
};

export const updateSettingsByConditions = (
  settings: IControlSettingUI[],
  variables: string[],
): IControlSettingUI[] => {
  const evaluate = (controls: IControlSettingUI[]): IControlSettingUI[] =>
    controls.map((control) => {
      const { hide, condition, configs, controls } = control;

      const updatedHide = evaluateHide(hide, condition, variables);

      const updatedConfigs = configs?.map((cfg) => ({
        ...cfg,
        hide: evaluateHide(cfg.hide, cfg.condition, variables),
      }));

      const updatedChildren = controls?.length ? evaluate(controls) : controls;

      return {
        ...control,
        hide: updatedHide,
        configs: updatedConfigs,
        controls: updatedChildren,
      };
    });

  return evaluate(settings);
};
